import Layout from "./components/Layout";
import Main from "./pages";
import ErrorFallback from "./components/ErrorFallback";

export const RouterInfo = [
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorFallback />,
    children: [
      {
        index: true,
        element: <Main />,
        label: "main",
      },
    ],
  },
];
